import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';
import homeNavShadow from '../../assets/images/home_nav_shadow.png';

export const AppWrapperStyled = styled.div`
  color: ${props => props.theme.primaryColor};
  font-family: ${props => props.theme.primaryFontFamily};
  font-size: ${props => props.theme.fontSize};
  line-height: ${props => props.theme.lineHeight};
`;

export const LightWrapperStyled = styled(AppWrapperStyled)`
  background: ${p => `linear-gradient(to left, ${p.firstColor}, ${p.secondColor})`};
`;

export const Background = styled.div`
  background: ${props => `url(${props.backgroundImages.desktop}) no-repeat center center fixed`};
  ${media.medium`
    background: ${props => `url(${props.backgroundImages.tablet}) no-repeat center center fixed`};
  `}
  ${media.small`
    background: ${props => `url(${props.backgroundImages.mobile}) no-repeat center center fixed`};
  `}
  background-size: cover;
  background-attachment: initial;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  overflow: hidden;
  &::after {
    content: url('${homeNavShadow}');
    position: relative;
    left: 50%;
    margin-left: -631px;
  }
`;

export const BackgroundImg = styled.img`
  background: ${p => `url(${p.backgroundImages}) no-repeat center center fixed`};
  background-size: cover;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  flex-grow: 1;
  max-height: 100vh;
  ${media.small`
    position: absolute;
  `}
`;

export const StickyMobileHeader = styled.div`
  position: relative;
  ${media.small`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
  `}
`;

export const AppWrapper = styled.div`
  ${media.small`
    margin-top: ${p => p.extraMargin ? '6rem' : 0};
  `}
`;



// WEBPACK FOOTER //
// ./components/ThemeAllocator/template.style.js